import { Injectable } from '@angular/core';
import {DMPrincipalComponent} from '../../componentes/00-contenedores/docker-manager/dmprincipal/dmprincipal.component';
import { IgxInputDirective } from '@infragistics/igniteui-angular/input-group';
import {IShortcut} from '../models/interfaces/generico-interface';
import {KeyboardShortcutsComponent} from 'ng-keyboard-shortcuts';
import {EnumParaPpto} from '../models/enum/enum-parametros';
import {ClsCatalogoPresupuestos, ClsOrganizacion, ClsPartidasConceptosExpIns} from "../models/cls-presupuestos";
import { ClsParametro } from '../models/cls-parametros';
import {ClsListaArchivos} from "../models/cls-storage";

@Injectable({
  providedIn: 'root'
})
export class AppPresupuestosService {
  private _ORGANIZACION: ClsOrganizacion;
  private _DMPRINCIPAL: DMPrincipalComponent;
  private _PPTOSELECCIONADOACTIVO: ClsCatalogoPresupuestos = undefined;
  private _PPTOSELECCIONADOMAESTRO: ClsCatalogoPresupuestos = undefined;
  private _PPTOACTIVOCOMPLETOJSON: ClsPartidasConceptosExpIns = new ClsPartidasConceptosExpIns();
  private _PPTOMAESTROCOMPLETOJSON: ClsPartidasConceptosExpIns = new ClsPartidasConceptosExpIns();
  private _ESPPTOMAESTRO: boolean;
  private _VARIOSTABSMAESTRO: boolean;
  private _VARIOSTABSACTIVO: boolean;
  private _ENEDICIONCONCEPTOS: boolean;
  private _ENEDICIONMATRIZ: boolean;
  private _CHECKMAESTROEXPINS: boolean;
  private _ENEDICIONPROGRAMAPORCENTAJE: boolean;
  private _PARAMETROSPPTO: ClsParametro[];
  private _PARAMETROSORGANIZACION: ClsParametro[];
  private _PARAMETROSUSUARIO: ClsParametro[];
  private _COMPONENTESOBRECOSTO: IgxInputDirective;
  private _ARRAYSHORTCUT: IShortcut[];
  private _KEYBOARD: KeyboardShortcutsComponent;
  private _DOCSCSELEC1: ClsListaArchivos;
  private _DOCSCSELEC2: ClsListaArchivos;
  private _DOCPIEINDSELEC1: ClsListaArchivos;
  private _DOCPIEINDSELEC2: ClsListaArchivos;
  private _DOCFASARSELEC1: ClsListaArchivos;
  private _DOCFASARSELEC2: ClsListaArchivos;
  // decimales para redondeo matrices
  private _DECIMALREDONDEOMATRICES = 6;
  // decimales a redondear
  private _DECIMALREDONDEARIMPORTE: number;
  private _DECIMALREDONDEARCANTIDAD: number;
  private _DECIMALREDONDEAREXPINS: number;
  // decimales a redondear maestro
  private _DECIMALREDONDEARIMPORTEMAESTRO: number;
  private _DECIMALREDONDEARCANTIDADMAESTRO: number;
  private _DECIMALREDONDEAREXPINSMAESTRO: number;
  // datos para partida
  private _PPTOCOSTOTOTAL: number;
  private _PPTOPRECIOTOTAL: number;
  private _CALPARAMONEDAS: number;
  private _CALDECCU: string;
  // datos para partida maestro
  private _PPTOCOSTOTOTALMAESTRO: number;
  private _PPTOPRECIOTOTALMAESTRO: number;
  private _CALPARAMONEDASMAESTRO: number;
  private _CALDECCUMAESTRO: string;
  // mapa de campos generales
  private _MAPCAMPOSGENERELES: Map<string, any> = new Map<string, any>();
  constructor() { }

  public setValorRedondeoImporteCantidadExpIns(parametrosPpto: ClsParametro[]) {
    this.decimalredondearimporte = Number(parametrosPpto.find(para => para.Parametro === EnumParaPpto.CALDECCU).Valor);
    this.decimalredondearcantidad = Number(parametrosPpto.find(para => para.Parametro === EnumParaPpto.CALDECCANTPPTO).Valor);
    this.decimalredondearexpins = Number(parametrosPpto.find(para => para.Parametro === EnumParaPpto.CALDECEXPINS).Valor);
  }

  get decimalredondearmatrices(): number {
    return this._DECIMALREDONDEOMATRICES;
  }
  get decimalredondearimporte(): number {
    if (this.esPptoMaestro) {
      return this._DECIMALREDONDEARIMPORTEMAESTRO;
    } else {
      return this._DECIMALREDONDEARIMPORTE;
    }
  }
  set decimalredondearimporte(value: number) {
    if (this.esPptoMaestro) {
      this._DECIMALREDONDEARIMPORTEMAESTRO = value;
    } else {
      this._DECIMALREDONDEARIMPORTE = value;
    }
  }
  get decimalredondearcantidad(): number {
    if (this.esPptoMaestro) {
      return this._DECIMALREDONDEARCANTIDADMAESTRO;
    } else {
      return this._DECIMALREDONDEARCANTIDAD;
    }
  }
  set decimalredondearcantidad(value: number) {
    if (this.esPptoMaestro) {
      this._DECIMALREDONDEARCANTIDADMAESTRO = value;
    } else {
      this._DECIMALREDONDEARCANTIDAD = value;
    }
  }
  get decimalredondearexpins(): number {
    if (this.esPptoMaestro) {
      return this._DECIMALREDONDEAREXPINSMAESTRO;
    } else {
      return this._DECIMALREDONDEAREXPINS;
    }
  }
  set decimalredondearexpins(value: number) {
    if (this.esPptoMaestro) {
      this._DECIMALREDONDEAREXPINSMAESTRO = value;
    } else {
      this._DECIMALREDONDEAREXPINS = value;
    }
  }
  public setValorTituloPartidas(paramPpto: ClsParametro[]) {
    this.pptocostototal = Number(paramPpto.find(para => para.Parametro === EnumParaPpto.PPTOCOSTOTOTAL).Valor);
    this.pptopreciototal = Number(paramPpto.find(para => para.Parametro === EnumParaPpto.PPTOPRECIOTOTAL).Valor);
    this.calparamonedas = Number(paramPpto.find(para => para.Parametro === EnumParaPpto.CALPARAMONEDAS).Valor);
    this.caldeccu = paramPpto.find(para => para.Parametro === EnumParaPpto.CALDECCU).Valor;
  }
  get pptocostototal(): number {
    if (this.esPptoMaestro) {
      return this._PPTOCOSTOTOTALMAESTRO;
    } else {
      return this._PPTOCOSTOTOTAL;
    }
  }
  set pptocostototal(value: number) {
    if (this.esPptoMaestro) {
      this._PPTOCOSTOTOTALMAESTRO = value;
    } else {
      this._PPTOCOSTOTOTAL = value;
    }
  }
  get pptopreciototal(): number {
    if (this.esPptoMaestro) {
      return this._PPTOPRECIOTOTALMAESTRO;
    } else {
      return this._PPTOPRECIOTOTAL;
    }
  }
  set pptopreciototal(value: number) {
    if (this.esPptoMaestro) {
      this._PPTOPRECIOTOTALMAESTRO = value;
    } else {
      this._PPTOPRECIOTOTAL = value;
    }
  }
  get calparamonedas(): number {
    if (this.esPptoMaestro) {
      return this._CALPARAMONEDASMAESTRO;
    } else {
      return this._CALPARAMONEDAS;
    }
  }
  set calparamonedas(value: number) {
    if (this.esPptoMaestro) {
      this._CALPARAMONEDASMAESTRO = value;
    } else {
      this._CALPARAMONEDAS = value;
    }
  }
  get caldeccu(): string {
    if (this.esPptoMaestro) {
      return this._CALDECCUMAESTRO;
    } else {
      return this._CALDECCU;
    }
  }
  set caldeccu(value: string) {
    if (this.esPptoMaestro) {
      this._CALDECCUMAESTRO = value;
    } else {
      this._CALDECCU = value;
    }
  }
  get organizacion(): ClsOrganizacion {
    return this._ORGANIZACION;
  }
  set organizacion(value: ClsOrganizacion) {
    this._ORGANIZACION = value;
  }
  get pptoActivoCompletoJSON() {
    return this._PPTOACTIVOCOMPLETOJSON;
  }
  set pptoActivoCompletoJSON(value: ClsPartidasConceptosExpIns) {
    this._PPTOACTIVOCOMPLETOJSON = value;
  }
  get pptoMaestroCompletoJSON() {
    return this._PPTOMAESTROCOMPLETOJSON;
  }
  set pptoMaestroCompletoJSON(value: ClsPartidasConceptosExpIns) {
    this._PPTOMAESTROCOMPLETOJSON = value;
  }
  get pptoSeleccionadoActivo() {
    return this._PPTOSELECCIONADOACTIVO;
  }
  set pptoSeleccionadoActivo(value: ClsCatalogoPresupuestos) {
    this._PPTOSELECCIONADOACTIVO = value;
  }
  get pptoSeleccionadoMaestro() {
    return this._PPTOSELECCIONADOMAESTRO;
  }
  set pptoSeleccionadoMaestro(value: ClsCatalogoPresupuestos) {
    this._PPTOSELECCIONADOMAESTRO = value;
  }
  get dmPrincipal() {
    return this._DMPRINCIPAL;
  }
  set dmPrincipal(value: DMPrincipalComponent){
    this._DMPRINCIPAL = value;
  }

  get esPptoMaestro() {
    return this._ESPPTOMAESTRO;
  }
  set esPptoMaestro(value: boolean) {
    this._ESPPTOMAESTRO = value;
  }
  set variosTabsActivo(value: boolean) {
    this._VARIOSTABSACTIVO =  value;
  }
  get variosTabsActivo(): boolean {
    return this._VARIOSTABSACTIVO;
  }
  set variosTabsMaestro(value: boolean) {
    this._VARIOSTABSMAESTRO =  value;
  }
  get variosTabsMaestro(): boolean {
    return this._VARIOSTABSMAESTRO;
  }
  set enEdicionConceptos(value: boolean) {
    this._ENEDICIONCONCEPTOS =  value;
  }
  get enEdicionConceptos(): boolean {
    return this._ENEDICIONCONCEPTOS;
  }
  set enEdicionMatriz(value: boolean) {
    this._ENEDICIONMATRIZ =  value;
  }
  get enEdicionMatriz(): boolean {
    return this._ENEDICIONMATRIZ;
  }
  set enEdicionProgramaPorcentaje(value: boolean) {
    this._ENEDICIONPROGRAMAPORCENTAJE =  value;
  }
  get enEdicionProgramaPorcentaje(): boolean {
    return this._ENEDICIONPROGRAMAPORCENTAJE;
  }
  set checkMaestroExpIns(value: boolean) {
    this._CHECKMAESTROEXPINS =  value;
  }
  get checkMaestroExpIns(): boolean {
    return this._CHECKMAESTROEXPINS;
  }
  set parametrosPpto(value: ClsParametro[]) {
    this._PARAMETROSPPTO =  value;
  }
  get parametrosPpto(): ClsParametro[] {
    return this._PARAMETROSPPTO;
  }
  set parametrosOrganizacion(value: ClsParametro[]) {
    this._PARAMETROSORGANIZACION =  value;
  }
  get parametrosOrganizacion(): ClsParametro[] {
    return this._PARAMETROSORGANIZACION;
  }
  set parametrosUsuario(value: ClsParametro[]) {
    this._PARAMETROSUSUARIO =  value;
  }
  get parametrosUsuario(): ClsParametro[] {
    return this._PARAMETROSUSUARIO;
  }
  set componenteSobrecosto(value: IgxInputDirective) {
    this._COMPONENTESOBRECOSTO =  value;
  }
  get componenteSobrecosto(): IgxInputDirective {
    return this._COMPONENTESOBRECOSTO;
  }
  get shortcut(): IShortcut[] {
    return this._ARRAYSHORTCUT;
  }
  set shortcut(value: IShortcut[]) {
    this._ARRAYSHORTCUT = value;
  }
  get keyboard(): KeyboardShortcutsComponent {
    return this._KEYBOARD;
  }
  set keyboard(value: KeyboardShortcutsComponent) {
    this._KEYBOARD = value;
  }
  get docSCSelec1(): ClsListaArchivos {
    return this._DOCSCSELEC1;
  }
  set docSCSelec1(value: ClsListaArchivos) {
    this._DOCSCSELEC1 = value;
  }
  get docSCSelec2(): ClsListaArchivos {
    return this._DOCSCSELEC2;
  }
  set docSCSelec2(value: ClsListaArchivos) {
    this._DOCSCSELEC2 = value;
  }

  get docPieIndSelec1(): ClsListaArchivos {
    return this._DOCPIEINDSELEC1;
  }
  set docPieIndSelec1(value: ClsListaArchivos) {
    this._DOCPIEINDSELEC1 = value;
  }
  get docPieIndSelec2(): ClsListaArchivos {
    return this._DOCPIEINDSELEC2;
  }
  set docPieIndSelec2(value: ClsListaArchivos) {
    this._DOCPIEINDSELEC2 = value;
  }
  get docFasarSelec1(): ClsListaArchivos {
    return this._DOCFASARSELEC1;
  }
  set docFasarSelec1(value: ClsListaArchivos) {
    this._DOCFASARSELEC1 = value;
  }
  get docFasarSelec2(): ClsListaArchivos {
    return this._DOCFASARSELEC2;
  }
  set docFasarSelec2(value: ClsListaArchivos) {
    this._DOCFASARSELEC2 = value;
  }
  get mapCamposGenerales(): Map<string, any> {
    return this._MAPCAMPOSGENERELES;
  }
  set mapCamposGenerales(value: Map<string, any>) {
    this._MAPCAMPOSGENERELES = value;
  }
}
